module.exports = __webpack_public_path__ + "static/media/thumb-student-progress.b27071aa.png";